import React, { useState, useEffect } from "react";
import { BackgroundImage, HeaderComponent, Map } from "../../FourthComponents";
import { IoCall, IoMail, IoTime } from "react-icons/io5";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaLocationArrow } from "react-icons/fa";
import { IoLogoGoogleplus } from "react-icons/io";
import { Button, Form, Input } from 'antd';
import axios from 'axios';
import { POST } from '../../utils/apis';
import { errorMessage, successMessage } from '../../utils/helpers';

const FourthContact = (props) => {
    const { selectedLanguage } = props
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [isHeaderFixed, setIsHeaderFixed] = useState(false)

    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 40) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const onFinish = (values) => {
        setLoading(true)
        values.designName = 'clinic-design-4'
        axios.post(POST?.CREATE_CONTACT_FORM, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                form.resetFields()
                if (data?.success) {
                    successMessage(data?.message)
                } else {
                    errorMessage(data?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                form.resetFields()
                errorMessage(e?.message)
            })
    }

    return (
        <div className={isHeaderFixed ? "frth-design-screens-main" : ""}>
            <BackgroundImage {...props} heading={selectedLanguage?.txt_we_are_cairo_capital_clinics} screenName={selectedLanguage?.txt_we_would_love_to_hear_from_you} mainClass={'frth-design-contact-banner'} />
            <div className="frth-des-contact-info-main">
                <div className="frth-des-contact-info-left-div">
                    <h2>
                        {selectedLanguage?.txt_hospital_info}
                    </h2>
                    <hr />
                    <div>
                        <div>
                            <button>
                                <FaLocationArrow />
                            </button>
                            <p>
                                {selectedLanguage?.txt_3_taha_hussein_street}
                                <br />
                                {selectedLanguage?.txt_el_yamama_center_zamalek_cairo}
                            </p>
                        </div>
                        <div>
                            <button>
                                <IoCall />
                            </button>
                            <p>
                                (+20) 100 0066654
                            </p>
                        </div>
                        <div>
                            <button>
                                <IoMail />
                            </button>
                            <p>
                                info@cairocapitalclinics.com
                            </p>
                        </div>
                        <div>
                            <button>
                                <IoTime />
                            </button>
                            <p>
                                {selectedLanguage?.txt_mon_fri}
                                <br />
                                {selectedLanguage?.txt_sat_sun}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="frth-des-contact-info-right-div">
                    <h2>
                        {selectedLanguage?.txt_network}
                    </h2>
                    <hr />
                    <div>
                        <button><FaTwitter /></button>
                        <button><FaFacebookF /></button>
                        <button><IoLogoGoogleplus /></button>
                        <button><FaLinkedinIn /></button>
                    </div>
                </div>
            </div>
            <HeaderComponent title={selectedLanguage?.txt_get_in_touch} />
            <div className="frth-des-contact-form-main">
                <Form
                    labelCol={{ span: 24 }}
                    className='frth-des-form'
                    name='form'
                    form={form}
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={true}
                >
                    <div className='frth-des-form-div'>
                        <div>
                            <div>
                                <Form.Item
                                    className=""
                                    name='name'
                                >
                                    <Input className="frth-des-contact-inputs" placeholder={selectedLanguage?.name_label} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className=""
                                    name='email'
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.txt_please_enter_your_email_message,
                                        },
                                        {
                                            type: 'email',
                                            message: selectedLanguage?.EmailIsNotValid,
                                        },
                                    ]}
                                >
                                    <Input className="frth-des-contact-inputs" placeholder={selectedLanguage?.input_email_placeholder} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className=""
                                    name='number'
                                >
                                    <Input type="number" className="frth-des-contact-inputs" placeholder={selectedLanguage?.input_number_placeholder} />
                                </Form.Item>
                            </div>
                        </div>
                        <div>
                            {/* <div>
                                <Form.Item
                                    className=""
                                    name='department'
                                >
                                    <Input className="frth-des-contact-inputs" placeholder={selectedLanguage?.txt_department} />
                                </Form.Item>
                            </div> */}
                            <div>
                                <Form.Item
                                    className=""
                                    name='message'
                                >
                                    <Input.TextArea autoSize={{ minRows: 8 }} className="frth-des-contact-inputs" placeholder={selectedLanguage?.txt_your_message} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='frth-des-contact-form-btn-div'>
                            <Form.Item
                                wrapperCol={{ span: 24, offset: 0 }}
                            >
                                <Button type="primary" htmlType="submit" loading={loading}>
                                    {selectedLanguage?.txt_send_message_}
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </div>
            <Map />
        </div>
    )
}

export default FourthContact